import LanguageSelector from "src/components/language/LanguageSelector";
import Link from "src/components/Link";
import Loader from "src/components/Loader";
import Logo from "src/components/Logo";

interface AuthLayoutProps {
	children?: any;
	head?: {
		title?: string;
		back?: {
			to?: string;
			label?: string;
		};
	};
	loading?: boolean;
}

const AuthLayout = ({ children, head, loading }: AuthLayoutProps) => {
	return (
		<div className="flex flex-1 flex-col-reverse md:flex-row">
			<div className="bg-white flex-1 w-full md:max-w-[720px] p-8 md:p-16 md:px-24 flex flex-col gap-4">
				{head && (
					<div className="flex items-start pb-8 justify-between md:mb-4">
						<div className="flex flex-col gap-4 md:gap-6">
							<h2>{head.title}</h2>
							{head.back?.to && (
								<Link to={head.back.to}>
									<i className="fal fa-arrow-left"></i>
									{head.back?.label && (
										<span className="ml-2">
											{head.back.label}
										</span>
									)}
								</Link>
							)}
						</div>
						<LanguageSelector theme={"dark"} />
					</div>
				)}
				{loading ? (
					<div className="flex flex-col flex-1 justify-center items-center">
						<Loader />
					</div>
				) : (
					<div className="flex flex-1 flex-col">{children}</div>
				)}
			</div>
			<div className="bg-dark md:flex-1 relative overflow-hidden">
				<div className="flex justify-between p-8 md:p-16">
					<Logo
						variant="default"
						color="white"
						className="max-w-[180px] md:max-w-[320px]"
					/>
				</div>
				<Logo
					variant="small"
					color="primary"
					className="max-w-md absolute -left-16 -bottom-16 opacity-10"
				/>
			</div>
		</div>
	);
};

export default AuthLayout;
